export default __webpack_public_path__ + "static/media/verified.a06c0667.svg";